import { TagProps } from "antd";

/**
 * The possible statuses of the factory and machine state.
 */
export type Status = "ok" | "warning" | "error";

/**
 * Maps the status to a color for the Chip component.
 */
export const statusToColor = (
  status: Status,
): NonNullable<TagProps["color"]> => {
  switch (status) {
    case "ok":
      return "success";
    case "warning":
      return "warning";
    case "error":
      return "error";
  }
};
